module.exports = __webpack_public_path__ + "static/media/icon_onboarding_kbd.407eacef.png";